import axios from 'axios';
const esc = encodeURIComponent;
const BASE_URL = 'https://tiketapasaja.com';
const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};
const validStatuses = [
  200, 201, 202, 203, 204,
  300, 301, 302, 303, 304,
];

let headers = {};

/*
* Returns default headers list
* which will be used with every request.
*/
export default {
  getHeaders () {
    let dataHeader = { ...DEFAULT_HEADERS, ...headers };

    return dataHeader;
  },

  setHeaders (params = {}) {
    headers = params;
  },

  checkResponse (response) {
    if (validStatuses.includes(response.status)) {
      return response;
    }

    // If not authorized then reset token
    // and redirect to login page
    if (response.status === 401) {
      localStorage.removeItem('token');
      return Promise.reject(new Error('USER_ANONYMOUS'));
    }

    let err = new Error(response.statusText);
    err.response = response;

    return Promise.reject(err);
  },

  processAPIErrors (apiErrors) {
    let errors = {};

    if (apiErrors) {
      for (let key of Object.keys(apiErrors)) {
        let err = apiErrors[key];

        errors[key] = err;

        if (typeof err === 'object' || err.hasOwnProperty('length')) {
          errors[key] = apiErrors[key][0];
        }
      }
    }

    return errors;
  },

  qs (params) {
    return (
      Object
        .keys(params)
        .map(k => esc(k) + '=' + esc(params[k]))
        .join('&')
    );
  },

  /*
  * Wraps axios and provides
  * more convenient post method
  * calls with data
  */
  post (uri, data, customConfig) {
    uri = this.e(uri);

    let config = {
      headers: this.getHeaders(),
      withCredentials: true,
    };

    if (customConfig) {
      Object.assign(config, customConfig);
    }

    return axios.post(uri, data, config);
  },

  /*
  * Wraps axios and provides
  * more convenient put method
  * calls with data
  */
  put (uri, data) {
    uri = this.e(uri);

    return axios.put(uri, data, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  },

  /*
  * Wraps axios and provides
  * more convenient delete method
  */
  remove (uri, data) {
    uri = this.e(uri);

    return axios.delete(uri, data, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  },

  /*
  * Wraps axios and provides
  * more convenient get method
  * calls with data.
  */
  get (uri, data = {}) {
    uri = this.e(uri);

    if (Object.keys(data).length > 0) {
      uri = `${uri}?${this.qs(data)}`;
    }

    return axios.get(uri, {
      headers: this.getHeaders(),
      withCredentials: true,
    });
  },

  upload (uri, data) {
    uri = this.e(uri);
    return fetch(uri, {
      headers: this.getHeaders(true),
      cors: true,
      method: 'POST',
      body: data,
    });
  },

  // Means endpoint
  e (uri) {
    return BASE_URL + uri;
  },
};
